import Check from '@mui/icons-material/Check'
import Refresh from '@mui/icons-material/Refresh'
import { Suspense, useContext, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { isUserAllowedToAccessContent } from 'src/consumer/components/ActivityPlansPage/activityPlanHelpers'
import { APArticleTextContainer } from 'src/consumer/components/ArticlePage/ArticlePageStyles'
import { getPracticeTimerById } from 'src/consumer/components/TimersPage/utils'
import { CustomReactPlayer } from 'src/consumer/components/helperComponents/dynamic'
import { ActivityDetailsPlayer } from 'src/consumer/components/helperComponentsStyles'
import { AP_REPORT_TYPES } from 'src/consumer/constants'
import { JournalContext } from 'src/consumer/context/JournalContext'
import { PlayerContext } from 'src/consumer/context/PlayerContext'
import { resetPlayerData } from 'src/consumer/helpers/playerHelper'
import { getParseDataFromHtmlString } from 'src/consumer/helpers/utilFunctions'
import {
  getAssessmentData,
  getCourseData,
  getFeatureItemBySlug,
  getJournalDataBySlug,
  getMentalStateType,
  getQuoteData,
  putDataWithParams,
} from 'src/consumer/services/featureServices'
import { getAuthToken } from 'src/consumer/services/localstorageServices'
import {
  getImageLink,
  isCommonResponseSuccessful,
  sleep,
} from 'src/mentor/helpers/utilityFunctions'
import { MarkCompletedButton, RedoActivityButton, StartActvityButton } from '../../MyPlanStyles'
import { getPlayerDataForActivity } from '../../user-activity-plan-helpers'
import {
  PlannedActivityStartedButtonsContainer,
  UAPBegunActivityStepIndicator,
  UAPBegunActivityStepIndicatorLine,
  UAPBegunActivityStepItemsContainer,
  UAPBegunActivityStepsContainer,
} from './styledComponents'

export default function PlannedActivityStartedComponent({
  planItem,
  planItemIdx,

  setupData,
  refreshActivityPlan,
  togglePrewall,
  profileData,
  setMentalStateDialogOpen,
  setMentalStateDialogData,
  setQuoteDialogOpen,
  setQuoteData,
  toggleAppExclusiveModal,
  activityPlan,
  signedUrls,

  activityHasPassed,
}) {
  const activityObject = planItem?.plannedActivity
  const { setJournalData } = useContext(JournalContext)
  const { playerData, setPlayerData } = useContext(PlayerContext)
  const [loadingData, setLoadingData] = useState(false)
  const [markingCompleted, setMarkingCompleted] = useState(false)
  const [steps, setSteps] = useState(1)

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { planId: urlPlanId } = useParams()

  const mainActivityCategory = setupData?.metaCategories?.find(
    (cat) => cat?.id === activityObject?.metaCategoryId,
  )

  const categoryTypeOfPlannedItem = mainActivityCategory?.categoryType

  async function afterFinishActivityFunction() {
    await refreshActivityPlan()
    stepUp()
  }

  async function markActivityAsCompleted() {
    setMarkingCompleted(true)
    const response = await putDataWithParams(
      '/api/secure/user/activity/mark-completed-offline',
      {},
      {
        planId: activityPlan?.id,
        day: planItemIdx,
        updateType: AP_REPORT_TYPES.completed,
        plannedActivityId: planItem?.id,
      },
    )
    if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      afterFinishActivityFunction()
      toast.success('Activity marked as completed')
    } else {
      toast.error('Error in marking activity as completed')
    }
    setMarkingCompleted(false)
  }

  async function takeActionOnStart(recordActivity = true) {
    setLoadingData(true)
    // Getting Data about activity

    // await startActivity(
    //   categoryTypeOfPlannedItem,
    //   planItem?.id,
    //   activityObject?.activityId,
    //   { setJournalData, navigate, urlPlanId, refreshActivityPlan },
    // )

    var srcIdToUse = null
    var src = null

    if (recordActivity) {
      srcIdToUse = planItem?.id
      src = 'planned-activity'
    }

    let response
    if (categoryTypeOfPlannedItem === 'article') {
      response = await getFeatureItemBySlug('article', activityObject?.activityId, false)
      if (response.status === 200 && isCommonResponseSuccessful(response.data.code)) {
        response = { data: response?.data?.data?.article, status: 200 }
      } else {
        response = { data: null, status: 500 }
      }
    } else if (categoryTypeOfPlannedItem === 'assessment') {
      response = await getAssessmentData(activityObject?.activityId, false)
    } else if (categoryTypeOfPlannedItem === 'journal') {
      response = await getJournalDataBySlug(activityObject?.activityId, false)
    } else if (categoryTypeOfPlannedItem === 'quotes') {
      response = await getQuoteData(activityObject?.activityId, false)
    } else if (categoryTypeOfPlannedItem === 'course') {
      if (activityObject?.customFields?.courseId) {
        response = await getCourseData(
          activityObject?.customFields?.courseId,
          activityObject?.activityId,
        )
      }
    } else if (categoryTypeOfPlannedItem === 'mentalStateType') {
      response = await getMentalStateType(activityObject?.activityId)
    } else if (categoryTypeOfPlannedItem === 'practice') {
      response = await getPracticeTimerById(activityObject?.activityId)
    }
    setLoadingData(false)
    await sleep(200)

    // After API data about activity
    if (response?.status === 200) {
      if (
        isUserAllowedToAccessContent(
          profileData?.subscriptionTypeId,
          categoryTypeOfPlannedItem === 'course'
            ? response?.data?.course?.subscription?.id
            : response?.data?.subscription?.id,
        )
      ) {
        if (categoryTypeOfPlannedItem === 'article') {
          // dispatch({
          //   type: 'set',
          //   articleGoBackState: {
          //     onClick: () => navigate(`/my-activity/${urlPlanId}`),
          //     text: 'Go Back to plan page',
          //   },
          // })
          navigate(`/article/id/${activityObject?.activityId}?src=${src}&src-id=${srcIdToUse}`, {
            state: {
              passedArticleData: response?.data,
            },
          })
        } else if (categoryTypeOfPlannedItem === 'assessment') {
          // dispatch({
          //   type: 'set',
          //   assessmentGoBackState: {
          //     onClick: () => navigate(`/my-activity/${urlPlanId}`),
          //     text: 'Go Back to plan page',
          //   },
          // })
          navigate(`/assessment/id/${activityObject?.activityId}?src=${src}&src-id=${srcIdToUse}`, {
            state: {
              passedAssessmentData: response?.data,
            },
          })
        } else if (categoryTypeOfPlannedItem === 'journal') {
          setJournalData({
            showJournal: true,
            callSource: 'tilespage',
            data: {
              ...response?.data,
              callSourceId: srcIdToUse,
              sourceName: src,
            },
            pageState: '',
            subscription: '',
            afterSubmitFunction: afterFinishActivityFunction,
          })
        } else if (categoryTypeOfPlannedItem === 'course') {
          setPlayerData({
            ...resetPlayerData(playerData),
            showPlayer: true,
            selectedCard: playerData.showPIP
              ? playerData?.selectedCard
              : getPlayerDataForActivity(
                  response?.data?.course,
                  response?.data?.teacher,
                  activityObject?.activityId,
                ),
            afterRatingFunction: afterFinishActivityFunction,
            source: src,
            id: srcIdToUse,
          })
        } else if (categoryTypeOfPlannedItem === 'mentalStateType') {
          setMentalStateDialogOpen(true)
          setMentalStateDialogData({
            ...response?.data,
            // options: mentalStateTypesOptions,
            src: src,
            srcId: srcIdToUse,
          })
        } else if (categoryTypeOfPlannedItem === 'quotes') {
          setQuoteData({
            ...response?.data,
            src: src,
            srcId: srcIdToUse,
            showCongratulatoryMessage: false,
          })
          await sleep(200)
          setQuoteDialogOpen(true)
        } else if (categoryTypeOfPlannedItem === 'practice') {
          navigate(`/timer/i/${activityObject?.activityId}?src=${src}&src-id=${srcIdToUse}`, {
            state: {
              item: response?.data,
            },
          })
        }
      } else {
        togglePrewall()
      }
    } else {
      toggleAppExclusiveModal()
    }
  }

  function showActivityDetails(
    passedSignedUrl,
    imageId = 'MEDIA-5fbc62a104cf4a328648c1fe81da3faa',
  ) {
    return passedSignedUrl?.signedUrl ? (
      <ActivityDetailsPlayer>
        <Suspense fallback={<div style={{ padding: '20px', textAlign: 'center' }}>Loading player...</div>}>
          <CustomReactPlayer
            config={{
              file: {
                // forceHLS: true,
                hlsOptions: {
                  debug: false,
                  xhrSetup: function (xhr, signedURL) {
                    xhr.setRequestHeader('Authorization', `Bearer ${getAuthToken()}`)
                  },
                  // enableWebVTT: true,
                },
              },
            }}
            url={`${passedSignedUrl?.signedUrl}`}
            width={'100%'}
            height={'100%'}
            onFinish={() => stepUp()}
            defaultBackgroundImageUrl={getImageLink(imageId)}
            containerStyles={{
              borderRadius: '10px',
              overflow: 'hidden',
              boxShadow: '0px 0px 6px 1px #0000005c',
            }}
            playerControlsStyles={{
              borderRadius: '0px 0px 10px 10px',
              overflow: 'hidden',
            }}
          />
        </Suspense>
      </ActivityDetailsPlayer>
    ) : (
      <APArticleTextContainer>
        {passedSignedUrl?.content && getParseDataFromHtmlString(passedSignedUrl?.content)}
      </APArticleTextContainer>
    )
  }

  function stepUp() {
    setSteps((prev) => prev + 1)
  }

  return (
    <UAPBegunActivityStepsContainer>
      <PlannedActivityInfoItemsWrapper completed={steps >= 2} disabled={steps < 1}>
        <span className="step-text">Step 1</span>
        {showActivityDetails(signedUrls?.pre, 'MEDIA-5fbc62a104cf4a328648c1fe81da3faa')}
      </PlannedActivityInfoItemsWrapper>
      <PlannedActivityInfoItemsWrapper completed={steps >= 3} disabled={steps < 2}>
        <span className="step-text">Step 2</span>
        <PlannedActivityStartedButtonsContainer className="activity-step-item">
          {activityHasPassed ? (
            <RedoActivityButton onClick={() => takeActionOnStart(false)}>
              <span>Replay Activity</span>
              <Refresh />
            </RedoActivityButton>
          ) : (
            <>
              <StartActvityButton
                disabled={loadingData}
                onClick={!loadingData && !markingCompleted && takeActionOnStart}
              >
                START ACTIVITY
                {loadingData && (
                  <Spinner
                    style={{ position: 'absolute', color: '#50416c' }}
                    animation="border"
                    variant="light"
                    size="sm"
                  />
                )}
              </StartActvityButton>
              <span className="or-text">or</span>
              <MarkCompletedButton
                disableRipple
                disabled={markingCompleted}
                onClick={markActivityAsCompleted}
              >
                <span>Start on my own</span>
                {markingCompleted && (
                  <Spinner
                    style={{ position: 'absolute', color: '#50416c' }}
                    animation="border"
                    variant="light"
                    size="sm"
                  />
                )}
              </MarkCompletedButton>
            </>
          )}
        </PlannedActivityStartedButtonsContainer>
      </PlannedActivityInfoItemsWrapper>
      <PlannedActivityInfoItemsWrapper completed={steps >= 4} disabled={steps < 3}>
        <span className="step-text">Step 3</span>
        <div className="activity-step-item">
          {showActivityDetails(signedUrls?.post, 'MEDIA-5cd41164196b4236a34e5c5fc3be204f')}
        </div>
      </PlannedActivityInfoItemsWrapper>
      <PlannedActivityInfoItemsWrapper completed={steps >= 4} hideLine disabled={steps < 4}>
        <span className="step-text">COMPLETE</span>
      </PlannedActivityInfoItemsWrapper>
    </UAPBegunActivityStepsContainer>
  )
}

function PlannedActivityInfoItemsWrapper({ disabled, completed, hideLine = false, children }) {
  return (
    <div className="d-flex h-100 w-100 gap-2">
      <div className="d-flex flex-column align-items-center">
        <UAPBegunActivityStepIndicator completed={completed} disabled={disabled}>
          {completed && <Check fontSize="1rem" />}
        </UAPBegunActivityStepIndicator>
        <UAPBegunActivityStepIndicatorLine
          completed={completed}
          disabled={disabled}
          style={{ opacity: hideLine ? 0 : 1 }}
        />
      </div>
      <UAPBegunActivityStepItemsContainer className="mb-3" disabled={disabled}>
        {children}
      </UAPBegunActivityStepItemsContainer>
    </div>
  )
}
